<template>
  <div
    class="px-2 py-1 bg-gray-200 text-gray-700 rounded-lg flex justify-between items-center min-h-[28px] cursor-pointer"
    @click="emit('reveal')"
  >
    <span class="flex items-center">••••••••••••••</span>
    <span class="flex items-center">
      <vue-feather type="eye-off" size="16" />
    </span>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  reveal: [];
}>();
</script>
